import React, { useEffect, useState } from 'react';
import { Close, Search, SearchOutlined } from '@mui/icons-material';
import { Link, Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Grid,
  IconButton,
  Divider,
  Box
} from '@mui/material';
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

import Page from '../../components/Page';
import OtpInput from 'react-otp-input';

import onBoardingEkycServices from '../../services/onBoarding-ekyc-services';
import DialogMsg from '../global/DialogMsg';
import Loader from '../global/Loader';
import { useTranslation } from 'react-i18next';

const authObj = {
  apiKey: 'AIzaSyBhTkJB4bUKXBhpK3jbihvDfV_PRwoUjhg',
  authDomain: 'onboarding-vkyc.firebaseapp.com',
  projectId: 'onboarding-vkyc',
  storageBucket: 'onboarding-vkyc.appspot.com',
  messagingSenderId: '917891499045',
  appId: '1:917891499045:web:eeae0370b8115bb6802bcc',
  measurementId: 'G-MFED9C2EDH'
};

const {
  GetKYCStatus,
  ValidateMobileNumber,
  VerifyOTP,
  ResendOTP,
  SetFCMToken,
  GenerateTokenForEKYC
} = onBoardingEkycServices;

const setFcmTokenToApi = async (token, applicationNo) => {
  console.log('newApplication', applicationNo);
  const credential = {
    userId: 'admin',
    fcmToken: token,
    organizationId: '1',
    applicationNo: applicationNo
  };
  const setToken = await SetFCMToken(credential);
  console.log('setToken', setToken);
};

// Define a counter variable, callCount function just 3 time for FCM token generate
let callCount = 0;
// console.log('callCount', callCount);

async function initFCM(applicationNo) {
  console.log('newApplication', applicationNo);
  const firebase = window.firebase;
  const firebaseConfig = {
    ...authObj
  };
  console.log('firebase', firebase);

  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  } else {
    firebase.app(); // if already initialized, use that one
  }

  console.log('firebase', Notification.permission);

  if (Notification.permission === 'denied') {
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        const messaging = firebase.messaging();
        console.log('firebase', messaging);

        try {
          const token = await messaging.requestPermission();
          console.log('firebase', token);
          await setFcmTokenToApi(token, applicationNo);
        } catch (error) {
          alert('please provide permission for notification');
        }
      }
    } catch (error) {
      console.log('firebase', error);
      alert('error: please provide permission for notification');
    }
  } else {
    const messaging = firebase.messaging();
    try {
      const token = await messaging.getToken();
      console.log('firebase', token);
      await setFcmTokenToApi(token, applicationNo);
    } catch (error) {
      console.log('newApplication', applicationNo);
      console.log('firebase', error);
      // alert('Notification allowed');

      // Increment the counter
      callCount++;
      if (callCount < 3) {
        initFCM(applicationNo);
      }
    }
  }
}

const Home = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // const [mobileOtp, setMobileOtp] = useState('');
  const [mobileNumber, setMobileNumber] = useState(''); // mobile number state
  const [applicationNumber, setApplicationNumber] = useState(''); // Api response of mobile number state
  // const [verifyOtp, setVerifyOtp] = useState(''); // handleVerifyOTP Api response state
  const [openAlertDialog, setOpenAlertDialog] = useState(false);
  const [otp, setOtp] = useState(''); // OTP digit state used into dialog
  const [dialogMsg, setDialogMsg] = useState(false);
  const [openDialogeMsg, setOpenDialogeMsg] = useState(false);
  const [validationMsg, setValidationMsg] = useState(false);
  const [vkycStatus, setVkycStatus] = useState(null);
  const [openloader, setOpenloader] = useState(false);
  const [openDialogRekyc, setOpenDialogRekyc] = useState(false);
  const [isRekyc, setIsRekyc] = useState(false);

  console.log('vkycStatus', vkycStatus);
  console.log('isRekyc', isRekyc);

  // console.log('mobileOtp', mobileNumber, applicationNumber);

  // GetKYCStatus API
  const GetKYCStatusApi = async () => {
    try {
      setOpenloader(true);
      const hdrCredential = {
        applicationNo: null,
        kycType: 'FRESH_KYC',
        // kycType:
        //   vkycStatus?.KYC_STATUS === 'COMPLETED' || vkycStatus?.VKYC_STATUS === 'COMPLETED'
        //     ? 'RE_KYC'
        //     : 'FRESH_KYC',
        mobileNo: mobileNumber
      };
      const GetKYCStatusResponse = await GetKYCStatus(hdrCredential);
      if (GetKYCStatusResponse.status === 'SUCCESS') {
        setVkycStatus(GetKYCStatusResponse.data);
        // let GetKYCStatusResponse = { data: { VKYC_STATUS: 'COMPLETED', KYC_STATUS: 'COMPLETED' } };
        // setVkycStatus(GetKYCStatusResponse);
        if (
          GetKYCStatusResponse.data.VKYC_STATUS === 'COMPLETED' &&
          GetKYCStatusResponse.data.KYC_STATUS === 'COMPLETED'
        ) {
          setOpenDialogRekyc(true);
        } else {
          handleOpenDialog();
        }
      } else if (GetKYCStatusResponse.status === 'error' || GetKYCStatusResponse.status === 500) {
        setDialogMsg(
          GetKYCStatusResponse.error !== undefined
            ? GetKYCStatusResponse.error
            : t('Something went wrong')
        );
        setOpenDialogeMsg(true);
      } else {
        handleOpenDialog(); // status is complete or not or pending, we will next to validate mobile number, mobile number will look to ahead
        // setDialogMsg('Something went wrong');
        // setOpenDialogeMsg(true);
      }
    } catch (error) {
      // console.log('errorerror', error);
    } finally {
      setOpenloader(false);
    }
  };

  // Mobile number API
  const handleMobileOtp = async () => {
    try {
      const credential = {
        mobileNo: mobileNumber,
        // kycType: 'FRESH_KYC',
        channel: 'W',
        kycType:
          vkycStatus?.KYC_STATUS === 'COMPLETED' || vkycStatus?.VKYC_STATUS === 'COMPLETED'
            ? 'RE_KYC'
            : 'FRESH_KYC'
      };
      const ValidateMobileNumberResponse = await ValidateMobileNumber(credential);
      if (
        ValidateMobileNumberResponse.status === 'SUCCESS' ||
        ValidateMobileNumberResponse.status === 'randomNumber'
      ) {
        setApplicationNumber(ValidateMobileNumberResponse.applicationNo);

        localStorage.setItem(
          'journey',
          JSON.stringify({
            applicationNo: ValidateMobileNumberResponse.applicationNo,
            mobileNumber: mobileNumber
          })
        );
      } else if (ValidateMobileNumberResponse.status === 'FAILED') {
        setOpenDialogeMsg(true);
        setDialogMsg(ValidateMobileNumberResponse.message);
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(t('Something went wrong'));
      }
    } catch (error) {
      console.log('errorerror', error);
    }
  };
  // Mobile OTP API
  const handleVerifyOTP = async () => {
    try {
      const credential = { mobileNo: mobileNumber, applicationNo: applicationNumber, OTP: otp };
      const VerifyOTPResponse = await VerifyOTP(credential);
      if (VerifyOTPResponse.status === 'SUCCESS') {
        navigate('/in');
        // Token generate api call just for video notification
        handleGenerateTokenApi();
      } else if (VerifyOTPResponse.status === 'FAILED') {
        setOpenDialogeMsg(true);
        setDialogMsg(
          String(VerifyOTPResponse.message).toLowerCase() === 'index 0 out of bounds for length 0'
            ? 'We apologize for the inconvenience. Please try again later.'
            : VerifyOTPResponse.message
        );
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(t('Something went wrong'));
      }
    } catch (error) {
      console.log(error);
    } finally {
      // navigate('/in'); // for the time being
    }
  };
  // Resend OTP API
  const handleResendOTP = async () => {
    try {
      const credential = { mobileNo: mobileNumber, applicationNo: applicationNumber };
      const ResendOTPResponse = await ResendOTP(credential);
      if (ResendOTPResponse.status === 'SUCCESS') {
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Dialog open handler
  const handleOpenDialog = () => {
    if (mobileNumber !== '' && mobileNumber.length === 10) {
      setOpenAlertDialog(true);
      handleMobileOtp();
    } else {
      setValidationMsg(true);
    }
  };
  // Dialog close handler
  const closeAlertHandler = (e) => {
    setOpenAlertDialog(false);
    setDialogMsg('');
  };
  // Msg Dialog close handler
  const closeDialogMsgHandler = (e) => {
    setOpenDialogeMsg(false);
    setDialogMsg('');
  };

  useEffect(() => {
    // localStorage.clear();
    localStorage.removeItem('journey');
  }, []);

  // handleGenerateTokenApi API, same as api call at videoKyc page too.
  // Note: video call noitification will get through this
  const handleGenerateTokenApi = async () => {
    try {
      // setOpenloader(true);
      const headerCredential = {
        applicationNo: applicationNumber
      };

      const GenerateTokenResponse = await GenerateTokenForEKYC(headerCredential);
      if (GenerateTokenResponse.status === 'Success') {
        localStorage.setItem('callToken', GenerateTokenResponse?.data?.token);
        localStorage.setItem('channel', GenerateTokenResponse?.data?.channel);
        initFCM(applicationNumber);
      } else if (GenerateTokenResponse.status === 'Failed') {
        setOpenDialogeMsg(true);
        setDialogMsg(GenerateTokenResponse.message);
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(t('Something went wrong'));
      }
    } catch (error) {
      console.log('errorerror', error);
    } finally {
      // setOpenloader(false);
    }
  };
  // handleGenerateTokenApi API end

  return (
    <Page title="Onboarding ekyc">
      <Loader openloader={openloader} />
      <Box className="LoginOuter" sx={{ width: '100%', height: '100vh' }}>
        <Box className="loginInner">
          <Grid container justifyContent="center" alignItems="center">
            {/* left side start */}
            <Grid item md={6} sm={12} xs={12}>
              <Stack className="loginImgB">
                <Typography>
                  <img className="loginImg" src="../static/loginImg.png" alt="Image lady" />
                </Typography>
              </Stack>
            </Grid>
            {/* right side start */}
            <Grid item md={6} sm={12} xs={12}>
              <Box className="loginForm">
                <Box mb={3}>
                  <img src="../static/logo/finco-logo-w.png" alt="Logo" className="loginLogo" />
                  <Typography
                    // variant="h3"
                    textAlign="center"
                    sx={{ maxWidth: '300px', color: '#222', fontSize: '18px', fontWeight: 'bold' }}
                  >
                    {t('Digital kyc')}
                  </Typography>
                </Box>
                <Typography variant="h6" mt={4} mb={1} className="primarycolor">
                  {t('Verify Identity')}
                </Typography>
                <Typography variant="body2" className="primarycolor" mb={3}>
                  {t('Please fill in your contact details to start the process')}
                </Typography>
                <Typography variant="body2" mb={1}>
                  {t('Mobile Number')} {isRekyc ? t('REKYC') : ''}
                </Typography>
                <Box mb={2}>
                  <TextField
                    fullWidth
                    value={mobileNumber}
                    placeholder={t('Mobile Number')}
                    type="text"
                    variant="outlined"
                    onChange={(e) => {
                      if (e.target.value.length < 11) {
                        setMobileNumber(e.target.value);
                        // setValidationMsg(true);
                      }
                    }}
                    inputProps={{
                      className: 'textInput textInputBig'
                    }}
                    error={Boolean(
                      (mobileNumber !== '' && mobileNumber.length < 10 && validationMsg === true) ||
                        (mobileNumber === '' && validationMsg === true)
                    )}
                    helperText={
                      mobileNumber !== '' && mobileNumber.length < 10 && validationMsg === true
                        ? t('Please enter a valid 10-digit mobile number')
                        : mobileNumber === '' && validationMsg === true
                        ? t('Mobile number not to be blank')
                        : ''
                    }
                  />
                </Box>

                <Box mb={2}>
                  <Button
                    className="loginBtn"
                    fullWidth
                    // style={{ color: '#fff', padding: '12px 10px' }}
                    onClick={() => {
                      if (isRekyc === true) {
                        // handleMobileOtp();
                        handleOpenDialog();
                      } else {
                        GetKYCStatusApi();
                      }
                      // console.log('vkycStatus', vkycStatus);
                      // // if (vkycStatus && vkycStatus !== null) {
                      // if (
                      //   vkycStatus?.KYC_STATUS === 'PENDING' ||
                      //   vkycStatus?.VKYC_STATUS === 'PENDING'
                      // ) {
                      //   handleOpenDialog();
                      // } else {
                      //   setOpenDialogRekyc(true);
                      // }
                      // }
                    }}
                  >
                    {t('Next')}
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {/* OTP dialog */}
      <OTPDialog
        handleVerifyOTP={handleVerifyOTP}
        handleResendOTP={handleResendOTP}
        closeAlertHandler={closeAlertHandler}
        openAlertDialog={openAlertDialog}
        dialogTitle={t('Enter OTP')}
        dialogMsg={mobileNumber}
        OtpInput={OtpInput}
        otp={otp}
        setOtp={setOtp}
      />

      <DialogMsg
        openDialogeMsg={openDialogeMsg}
        dialogMsg={dialogMsg}
        dialogTitle={t('Message')}
        buttonText={t('Close')}
        closeDialogMsgHandler={closeDialogMsgHandler}
      />

      <Dialog
        // fullScreen
        maxWidth="lg"
        open={openDialogRekyc}
        onClose={(e) => {
          closeAlertHandler(e);
        }}
        className="alertDialogWrap"
      >
        <DialogTitle className="dialog-title" style={{ textAlign: 'center' }}>
          <Typography
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{ fontWeight: 'bold' }}
          >
            {t('Digital kyc status')}
          </Typography>
          <IconButton onClick={(e) => setOpenDialogRekyc(false)} size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers className="dialog-content">
          <Box className="dialogMsg" width="100%">
            <Typography variant="body2" textAlign="center">
              {t('Your digital kyc has been completed successfully')} <br />{' '}
              {t('are you sure you want to proceed with Re-Kyc.')}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions
          disableSpacing={false}
          className="popupAction"
          style={{ padding: '10px 15px' }}
        >
          <Button
            onClick={() => {
              setOpenDialogRekyc(false);
              setIsRekyc(true);
            }}
            variant="contained"
            className="mainBtn btnSm"
            style={{ margin: '0px 6px' }}
          >
            {t('REKYC')}
          </Button>
          <Button
            onClick={() => setOpenDialogRekyc(false)}
            className="mainBtn btnLink btnSm primaryBg"
            style={{ margin: '0px 6px' }}
          >
            {t('Cancel')}
          </Button>
        </DialogActions>
        <Divider />
        <Typography variant="body2" mb={1} mt={1} textAlign="center">
          {t('If you want to REKYC')}{' '}
          <Button
            onClick={() => {
              setIsRekyc(true);
              setOpenDialogRekyc(false);
            }}
          >
            {t('Click')}
          </Button>
        </Typography>
      </Dialog>
    </Page>
  );
};

export default Home;

function OTPDialog({
  openAlertDialog,
  closeAlertHandler,
  dialogMsg,
  dialogTitle,
  handleVerifyOTP,
  handleResendOTP,
  otp,
  setOtp
}) {
  const { t } = useTranslation();

  return (
    <Box>
      <Dialog
        // fullScreen
        maxWidth="lg"
        open={openAlertDialog}
        onClose={(e) => {
          closeAlertHandler(e);
        }}
        className="alertDialogWrap"
      >
        <DialogTitle className="dialog-title" style={{ textAlign: 'center' }}>
          <Typography
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{ fontWeight: 'bold' }}
          >
            {dialogTitle}
          </Typography>
          <IconButton onClick={(e) => closeAlertHandler()} size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          className="dialog-content"
          style={{ borderBottom: 'none', paddingBottom: '0px' }}
        >
          <Box className="dialogMsg" width="100%" textAlign="center">
            <Typography textAlign="center" variant="body2" mb={2}>
              {t('An 4 digit code has been sent to')} <br /> {dialogMsg}
            </Typography>
            <Typography
              textAlign="center"
              display="flex"
              justifyContent="center"
              alignItems="center"
              mb={2}
            >
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={4}
                shouldAutoFocus={true}
                renderSeparator={<span style={{ color: '#03989a' }}>-</span>}
                renderInput={(props) => <input {...props} />}
                inputStyle={{
                  margin: '0px 6px',
                  width: '45px',
                  height: '50px',
                  border: '1px solid #00BBBF',
                  borderRadius: '8px'
                }}
              />
            </Typography>
          </Box>
        </DialogContent>
        {/* <Typography variant="subtitle2">{otp}</Typography> */}
        <Box
          dividers
          Container
          justifyContent="center"
          alignItems="center"
          className="loginOTPDialog"
        >
          <Box textAlign="center" mt={2} mb={2} pl={1} pr={1}>
            <Button onClick={handleVerifyOTP} variant="contained" className="mainBtn">
              {t('Verify')}
            </Button>
            <Button onClick={closeAlertHandler} className="mainBtn mainBtnSec ml-2">
              {t('Cancel')}
            </Button>
          </Box>
          <Divider />
          <Typography mt={1} mb={2} variant="body2" textAlign="center">
            {t('Dont receive the OTP')}{' '}
            <Link className="linkText" onClick={handleResendOTP}>
              {t('Resend')}
            </Link>
          </Typography>
        </Box>
      </Dialog>
    </Box>
  );
}
